import { tripRoute, tripTypeLabel, TripLike } from "@/lib/trip";

/** A trip cell for the list tables: the route ("Pune → Mumbai, India" for a
 *  Domestic trip, "India → Japan" for an International one), with the
 *  Domestic/International type beneath it. Shared by the travel request and
 *  advance tables (My Reimbursements, Approver Queue). */
export function TripCell({ trip }: { trip: TripLike }) {
  const typeLabel = tripTypeLabel(trip);
  return (
    <div className="min-w-0">
      <p className="truncate font-medium">{tripRoute(trip)}</p>
      {typeLabel && <p className="text-xs text-muted-foreground">{typeLabel}</p>}
    </div>
  );
}
